<template>
  <v-container fill-height>
    <v-row justify='center'>
      <v-col cols='12' class='text-center'>
        <h3 class='display-3 grey--text text--lighten-2' style='font-weight: 300'>Loading...</h3>
        <br>
        <br>
        <v-progress-circular :size='90' :width=2 indeterminate color='grey lighten-2'></v-progress-circular>
        <!--
        <br>
        <br>
        <br>
        <br>
        <small class='grey--text'>If this page hangs for a <strong>long</strong> time, try re-logging in</small><br>
        <v-btn outline color='grey' small :to="{ name: 'Logout' }">Re-Login</v-btn>
        -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'full-page-loading'
}
</script>
